import RequestService from './request-service';

/**
 * Class for handling user bonuses
 */
export default class GetBonusRulesRequestService extends RequestService {
  constructor() {
    super();
    /**
     * Request endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.getBonusRules;
    /**
     * Set post params
     * @type {BetslipModel|Bt|Xe}
     */
    this.method = 'get';
    this.getParams = {
      brandId: APP_SETTINGS.brandId || 0,
    };
  }
}
